import styled, {createGlobalStyle} from "styled-components";
import {Tabs, Select, DatePicker, Radio, Table, Button, Tag} from "antd";

export const CustomerRequestsTab = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledTabs = styled(Tabs)`
    width: 100%;
    max-width: 1400px;

    .ant-tabs-content {
        background-color: white;
        border: 1px solid #aef001;
        border-top: 1px solid #aef001;
        padding: 24px;
        border-radius: 10px;
        min-height: 500px;
    }

    .ant-tabs-tab {
        background-color: white;
        border: none;
        margin-right: 24px;
        border-bottom: 1px solid #d9d9d9;
        &:hover {
            color: green !important;
        }
    }

    .ant-tabs-tab-active {
        background-color: white;
        border-bottom: none;
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: green !important;
        &:hover {
            color: green !important;
        }
    }

    .ant-tabs-ink-bar {
        background-color: green !important;
        &:hover {
            background-color: green !important;
        }
    }

    .ant-tabs-nav {
        border-bottom: none;
    }
`;

// Support Request Tab Styles
export const SupportRequestContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const StepsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 40px;
    padding: 10px 0;
    border-bottom: 1px solid #e8e8e8;

    @media (max-width: 992px) {
        gap: 30px;
    }

    @media (max-width: 768px) {
        gap: 20px;
        padding: 16px 0;
    }

    @media (max-width: 480px) {
        gap: 15px;
        padding: 12px 0;
        flex-wrap: wrap;
        justify-content: space-around;
    }
`;

export const StepItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    min-width: 200px;

    @media (max-width: 992px) {
        min-width: 160px;
        gap: 10px;
    }

    @media (max-width: 768px) {
        min-width: 120px;
        gap: 8px;
    }

    @media (max-width: 480px) {
        min-width: 100px;
        gap: 6px;
    }
`;

export const StepNumber = styled.div`
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: ${props =>
        props.$completed ? "#aef001" : props.$active ? "#aef001" : "#d3d3d3"};
    color: ${props => (props.$completed || props.$active ? "#000" : "white")};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    transition: all 0.3s ease;

    ${props =>
        props.$active &&
        !props.$completed &&
        `
        border: 4px solid #aef001;
    `}

    @media (max-width: 992px) {
        width: 45px;
        height: 45px;
        font-size: 22px;
    }

    @media (max-width: 768px) {
        width: 40px;
        height: 40px;
        font-size: 20px;
    }

    @media (max-width: 480px) {
        width: 35px;
        height: 35px;
        font-size: 18px;
    }
`;

export const StepDescription = styled.p`
    text-align: center;
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    max-width: 350px;

    @media (max-width: 992px) {
        font-size: 12px;
        max-width: 280px;
    }

    @media (max-width: 768px) {
        font-size: 11px;
        max-width: 200px;
    }

    @media (max-width: 480px) {
        font-size: 10px;
        max-width: 150px;
    }
`;

export const ContentContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    @media (max-width: 768px) {
        gap: 12px;
        margin-bottom: 16px;
    }
`;

export const SelectionCard = styled.div`
    background-color: white;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    position: relative;
    pointer-events: ${props => (props.$disabled ? "none" : "auto")};

    ${props =>
        props.$disabled &&
        `
        opacity: 0.6;
        
        h3, label, span {
            color: #bfbfbf !important;
        }
    `}
`;

export const SelectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const SelectionTitle = styled.h3`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;
`;

export const SelectionInfo = styled.span`
    font-size: 14px;
    color: #666;
    font-weight: 500;
`;

export const StyledSelect = styled(Select)`
    .ant-select-selector {
        border-radius: 6px !important;
        border-color: #d9d9d9 !important;

        &:hover {
            border-color: #aef001 !important;
        }
    }

    &.ant-select-focused .ant-select-selector {
        border-color: #aef001 !important;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.1) !important;
    }
`;

// Global dropdown styles
export const GlobalDropdownStyles = createGlobalStyle`
    .ant-select-dropdown {
        .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
            background-color: rgba(174, 240, 1, 0.1) !important;
            color: #333 !important;
            font-weight: 600 !important;
        }

        .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
            background-color: rgba(174, 240, 1, 0.2) !important;
        }

        .ant-select-item-option:hover:not(.ant-select-item-option-disabled) {
            background-color: rgba(174, 240, 1, 0.2) !important;
        }
    }

    .ant-picker-dropdown {
        .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
            background-color: #aef001 !important;
            color: #333 !important;
        }

        .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
            border-color: #aef001 !important;
        }

        .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
            background-color: rgba(174, 240, 1, 0.2) !important;
        }

        .ant-picker-today-btn {
            color: #aef001 !important;
        }
    }

    .ant-radio-checked .ant-radio-inner {
        border-color: #aef001 !important;
        background-color: #aef001 !important;
    }

    .ant-radio-checked .ant-radio-inner::after {
        background-color: #aef001 !important;
    }

    .ant-radio-wrapper:hover .ant-radio-inner {
        border-color: #aef001 !important;
    }

    .ant-radio-wrapper:hover .ant-radio-checked .ant-radio-inner {
        border-color: #aef001 !important;
        background-color: #aef001 !important;
    }
`;

export const DatePickerContainer = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
`;

export const TimeSelectionRow = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
`;

export const StyledDatePicker = styled(DatePicker)`
    border-radius: 6px !important;

    &:hover {
        border-color: #aef001 !important;
    }

    &.ant-picker-focused {
        border-color: #aef001 !important;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.1) !important;
    }
`;

export const CourierCountContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    label {
        font-size: 14px;
        color: #333;
    }

    .ant-input-number {
        border-radius: 6px;

        &:hover {
            border-color: #aef001 !important;
        }

        &.ant-input-number-focused {
            border-color: #aef001 !important;
            box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.1) !important;
        }
    }
`;

export const ActionButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;

    @media (max-width: 768px) {
        padding-top: 16px;
        justify-content: center;
    }
`;

export const SubmitButton = styled.button`
    background-color: #aef001;
    color: #333;
    border: none;
    padding: 12px 40px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        background-color: #9dd401;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(174, 240, 1, 0.3);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        background-color: #d3d3d3;
        cursor: not-allowed;
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        padding: 10px 32px;
        font-size: 15px;
        width: 100%;
        max-width: 300px;
    }

    @media (max-width: 480px) {
        padding: 8px 24px;
        font-size: 14px;
    }
`;

// Courier Planning Request Styles
export const RequestTypeSelection = styled.div`
    background-color: #f9f9f9;
    padding: 16px 20px;
    border-radius: 8px;
    border: 1px solid #e8e8e8;

    .ant-radio-wrapper {
        font-size: 14px;
        margin-right: 24px;
    }

    .ant-radio-checked .ant-radio-inner {
        border-color: #aef001 !important;
        background-color: #aef001 !important;
    }

    .ant-radio-checked .ant-radio-inner::after {
        background-color: #aef001 !important;
    }

    .ant-radio-wrapper:hover .ant-radio-inner {
        border-color: #aef001 !important;
    }

    .ant-radio-wrapper:hover .ant-radio-checked .ant-radio-inner {
        border-color: #aef001 !important;
        background-color: #aef001 !important;
    }
`;

export const RequestTypeLabel = styled.p`
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
    line-height: 1.5;
`;

export const DecreaseRequestTextArea = styled.textarea`
    width: 100%;
    padding: 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    resize: vertical;
    min-height: 150px;
    transition: all 0.3s ease;

    &:focus {
        outline: none;
        border-color: #aef001;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.1);
    }

    &::placeholder {
        color: #bfbfbf;
    }
`;

export const DecreaseRequestInfo = styled.p`
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.6;
`;

export const DecreaseRequestWarning = styled.p`
    line-height: 1.6;
    background-color: #f9f9f9;
    padding: 12px 16px;
    border-radius: 6px;
    border-left: 3px solid #aef001;
    margin-bottom: 16px;
    font-size: 14px;
    color: #333;
    font-weight: 600;
    text-align: center;
`;

export const DecreaseConfirmation = styled.p``;

export const DecreaseButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 24px;
`;

export const ConfirmButton = styled.button`
    background-color: #52c41a;
    color: white;
    border: none;
    padding: 10px 40px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 120px;

    &:hover:not(:disabled) {
        background-color: #45a817;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(82, 196, 26, 0.3);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        background-color: #d3d3d3;
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const CancelButton = styled.button`
    background-color: #ff4d4f;
    color: white;
    border: none;
    padding: 10px 40px;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 120px;

    &:hover {
        background-color: #d9363e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;

// Requests Table Styles
export const RequestsTableContainer = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border: 1px solid #aef001;

    .ant-table {
        font-size: 14px;
    }

    .ant-table-thead > tr > th {
        background-color: #fafafa;
        font-weight: 600;
        color: #333;
    }

    .ant-pagination-item-active {
        border-color: #aef001;

        a {
            color: #333;
        }
    }

    .ant-pagination-item:hover {
        border-color: #aef001;
    }

    .ant-pagination-item-active:hover a {
        color: #333;
    }

    @media (max-width: 768px) {
        padding: 16px;
        margin-top: 16px;
    }
`;

export const TableTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #aef001;

    @media (max-width: 768px) {
        font-size: 16px;
        margin-bottom: 16px;
        padding-bottom: 8px;
    }
`;

// Responsive Table Component
export const ResponsiveTable = styled(Table)`
    width: 100%;
    @media (max-width: 768px) {
        .ant-table {
            font-size: 13px;
        }

        .ant-table-thead > tr > th {
            display: none;
        }

        .ant-table-tbody > tr {
            display: block;
            margin-bottom: 16px;
            border: 1px solid #e8e8e8;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            background: white;
            overflow: hidden;
        }

        .ant-table-tbody > tr > td {
            display: block;
            padding: 12px 16px;
            border: none;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
            padding-left: 40%;
        }

        .ant-table-tbody > tr > td:last-child {
            border-bottom: none;
        }

        .ant-table-tbody > tr > td::before {
            content: attr(data-label) ": ";
            position: absolute;
            left: 16px;
            top: 12px;
            width: 35%;
            font-weight: 600;
            color: #333;
            font-size: 12px;
        }

        .ant-table-tbody > tr > td:first-child {
            padding-top: 16px;
        }

        .ant-table-tbody > tr > td:last-child {
            padding-bottom: 16px;
        }

        .ant-pagination {
            text-align: center;
            margin-top: 20px;
        }

        .ant-pagination-item,
        .ant-pagination-prev,
        .ant-pagination-next {
            min-width: 32px;
            height: 32px;
            line-height: 30px;
            font-size: 12px;
        }
    }
`;

export const SortableHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    transition: color 0.3s ease;

    &:hover {
        color: #aef001;
    }

    .anticon {
        font-size: 12px;
        opacity: 0.7;
    }
`;

export const ActionButton = styled(Button)`
    border-radius: 6px;
    border-color: #d9d9d9;
    color: #333;
    font-size: 13px;
    height: 32px;
    padding: 4px 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.3s ease;

    &:hover {
        border-color: #aef001;
        color: #aef001;
        background-color: rgba(174, 240, 1, 0.1);
    }

    &:focus {
        border-color: #aef001;
        color: #aef001;
        background-color: rgba(174, 240, 1, 0.1);
    }

    .anticon {
        font-size: 14px;
    }
`;

// Detail Modal Styles
export const DetailModalContainer = styled.div`
    padding: 8px 0;
`;

export const DetailTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-bottom: 12px;
    border-bottom: 2px solid #aef001;
`;

export const InfoGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }
`;

export const InfoCard = styled.div`
    background-color: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
    }
`;

export const InfoCardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8e8e8;
`;

export const InfoCardIcon = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #aef001;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 14px;
    font-weight: bold;
`;

export const InfoCardTitle = styled.h4`
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0;
`;

export const InfoItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
`;

export const InfoLabel = styled.span`
    font-weight: 600;
    color: #333;
    font-size: 14px;
    flex: 1;
    margin-right: 12px;
`;

export const InfoValue = styled.span`
    color: #666;
    font-size: 14px;
    text-align: right;
    word-break: break-word;
    flex: 1;
`;

export const StatusTag = styled(Tag)`
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    padding: 2px 8px;
    margin: 0;
    align-self: flex-start;
`;

// Legacy styles for backward compatibility
export const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 24px;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 12px;
    }
`;

export const DetailSection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 8px 0;
`;

export const DetailLabel = styled.span`
    font-weight: 600;
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
`;

export const DetailValue = styled.span`
    color: #666;
    font-size: 14px;
    word-break: break-word;
`;
